import React, { useState, useRef, useEffect } from 'react';
import {
  Row,
  Col,
} from 'react-bootstrap';
import Editor from './htmlEditor';
import Categories from '../../utils/categories.functions';

const Product = () => {

  const fileUp = useRef();
  const [categories, setCategories] = useState([]);
  const [upload, setUpload] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [radio, setVisible] = useState({
    oculto: true,
    visible: false,
  })


  useEffect(() => {
    listadoCategoria();
  },[])

  const listadoCategoria = async () => {
    Categories.lista().then((categorias) => {
      setCategories(categorias);
    })
  }

  const onChangeRadio = (text) => {
    if (text === 'visible') {
      setVisible({
        oculto: false,
        [text]: true,
      })
    } else {
      setVisible({
        visible: false,
        [text]: true,
      })
    }
  }

  const openDialog = () => {
    fileUp.current.click();
  }

  const handleImageUpload = () => {
    setUpload(true);
    const { files } = document.querySelector('input[type="file"]')
    const formData = new FormData();
    formData.append('file', files[0]);
    // replace this with your upload preset name
    formData.append('upload_preset', 'ok9v9e6e');
    const options = {
      method: 'POST',
      body: formData,
    };

    return fetch('https://api.cloudinary.com/v1_1/dd5wtnlj9/image/upload', options)
      .then(res => res.json())
      .then(res => {
        setGallery([...gallery, res.secure_url]);
        setUpload(false);
      }) 
      .catch(err => setUpload(false));
  }

  return (
    <>
    <Row>
      <Col>
        <div className="grupo-input">
          <small>Producto</small>
          <input type="text" className="form-control input-border"/>
        </div>
      </Col>
      <Col>
        <div className="grupo-input">
          <small>Stock</small>
          <input type="text" className="form-control input-border"/>
        </div>
      </Col>

      <Col>
        <div className="grupo-input">
          <small>Precio</small>
          <input type="text" className="form-control input-border"/>
        </div>
      </Col>
    </Row>
    <Row>
      <Col lg={4}>
        <small>Visibilidad</small>
        <div className="grupo-input-radio">
          <div className="radio-input">
          <small className="label-radio">Oculto</small>
          <input onChange={() => onChangeRadio('oculto')} type="radio" name="visible" className="input-border" checked={radio.oculto}/>
          </div>
          <div className="radio-input">
          <small className="label-radio">Visible</small>
          <input onChange={() => onChangeRadio('visible')} type="radio" name="visible" className="input-border" checked={radio.visible}/>
          </div>
        </div>
      </Col>
      <Col lg={4}>
        <div className="grupo-input">
          <small>Precio oferta</small>
          <input type="text" className="form-control input-border"/>
        </div>
      </Col>
      <Col lg={4}>
        <div className="grupo-input">
          <small>Categoria</small>
          <select className="form-control">
            {categories.map((categoria,i) => {
              return <option key={i} value={categoria.id}>
                {categoria.description.toUpperCase()}
              </option>
            })}
          </select>
        </div>
      </Col>
    </Row>
    <Row>
      <Col>
      <div className="grupo-input">
        <div style={styles.editor}>
          <Editor/>
        </div>
      </div>
      </Col>
    </Row>
    <Row>
      <Col>
      <div className="gallery-product">
          {upload ? <div className="backdrop-gallery">
            <img alt="Cargando imagen..." src="https://www.principal.cl/formularios/general/img/loader.gif" style={{ width: 142, height: 75 }} /> 
            <small>Cargando...</small>
          </div> : null}
          <div onClick={openDialog} className="image-boxes photo-selected">
              <img alt="Seleccionar producto" src="https://image.flaticon.com/icons/png/512/48/48639.png" className="img-fluid"/>
              <input onChange={handleImageUpload} ref={fileUp} type="file" id="imgupload" style={{ display: 'none' }}/> 
          </div>
          {gallery.map((img,i) => {
             return <div key={i} className="image-boxes">
               <img alt={img} src={img} className="img-fluid-prop"/>
             </div>
          })}
      </div>
      </Col>
    </Row>
    </>
  )
}


const styles = {
  editor: {
    border: '1px solid #dfddddcc',
    minHeight: 350,
    marginTop: 10,
    borderRadius: 5,
  }
};

export default Product;